import React from 'react';
import useLocale from '../../../../../hooks/useLocale';
import { Form } from 'react-bootstrap';
import { CalenderInput } from '../../../../../components/base/CalenderInput';
import moment from 'moment';
import { FormProps } from './types';
import PagesHeader from '../../../../../components/base/PagesHeader';
import MonthAndYearDropdown from '../../../../../section/MonthAndYearDropdown';
import { MonthSelectOption } from '../../../../../types';
import { Calendar } from '../../../../../util/calendar';
import { Deployment as CompanyDeployment } from '../../../../superAdmin/CompanyClients/types';

const Deployment: React.FC<FormProps> = ({ formGroup, context }) => {
  const now = moment();
  const { localize } = useLocale();
  let minInvitationDate = now.toDate();
  let maxInvitationDate: Date | undefined = undefined;
  const companyRes = context.companyRes;
  const deployment = formGroup.getFieldMeta('deployment').value as CompanyDeployment;

  const upcomingSystemDeploymentMonthList: MonthSelectOption[] = Calendar.getMonthlyOptionAdapter({
    noOfMonths: 5,
    startFrom: Calendar.currentMonthStartDate,
    emptyMonths: true,
  });

  const onSystemDeploymentMonthChange = (month: string | null) => {
    context.updateDeployment('systemDeploymentMonth', month);
    context.updateDeployment('employeeInvitationSendOuts', null);
  };

  const onEmployeeInvitationSendOutsChange = (date: string | null) => {
    context.updateDeployment('employeeInvitationSendOuts', date);
  };

  if (!companyRes?.deployment) {
    console.log("JJJJJ")
     
    return null;
  }

  if (deployment.systemDeploymentMonth) {
    maxInvitationDate = moment(deployment.systemDeploymentMonth, 'YYYY-MM-DD').endOf('month').toDate();
  }

  return (
    <div>
      <PagesHeader pageTitle={localize('COMPANY.deployment')} headingClass="fs-h3 font-black" translate={false} />
      <div className="form-section mb-3 dark-content-section">
        <div className="cr-form-row">
          <div>
            <Form.Label className="fs-name mb-0">
              {localize('COMPANY.system_deployment_month')}
              <span className="font-weight-400 d-block theme-text">
                {localize('COMPANY.system_deployment_month_sub')}
              </span>
            </Form.Label>
            <MonthAndYearDropdown
              value={deployment.systemDeploymentMonth || ''}
              onOptionSelect={onSystemDeploymentMonthChange}
              customOptions={upcomingSystemDeploymentMonthList}
              disabled
            />
          </div>
          <div>
            <Form.Label className="fs-name mb-0">
              {localize('COMPANY.employee_invitation_send_outs')}
              <span className="font-weight-400 d-block theme-text">
                {localize('COMPANY.employee_invitation_send_outs_sub')}
              </span>
            </Form.Label>
            <div className="date-input">
              <CalenderInput
                onChangeHandler={onEmployeeInvitationSendOutsChange}
                showMonthYearPicker={false}
                minDate={minInvitationDate}
                maxDate={maxInvitationDate}
                datepicker
                value={deployment.employeeInvitationSendOuts}
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deployment;
